import blackGoldenDress1 from "../images/dress/blackGoldenDress1.webp";
import blackGoldenDress2 from "../images/dress/blackGoldenDress2.webp";
import blackGoldenDress3 from "../images/dress/blackGoldenDress3.webp";
import blackGoldenDress4 from "../images/dress/blackGoldenDress4.webp";

import blackMultiColor1 from "../images/dress/blackMultiColor1.webp";
import blackMultiColor2 from "../images/dress/blackMultiColor2.webp";
import blackMultiColor3 from "../images/dress/blackMultiColor3.webp";
import blackMultiColor4 from "../images/dress/blackMultiColor4.webp";

import blueBlackDress1 from "../images/dress/blueBlackDress1.webp";
import blueBlackDress2 from "../images/dress/blueBlackDress2.webp";
import blueBlackDress3 from "../images/dress/blueBlackDress3.webp";
import blueBlackDress4 from "../images/dress/blueBlackDress4.webp";

import blueConstrastDress1 from "../images/dress/blueConstrastDress1.webp";
import blueConstrastDress2 from "../images/dress/blueConstrastDress2.webp";
import blueConstrastDress3 from "../images/dress/blueConstrastDress3.webp";
import blueConstrastDress4 from "../images/dress/blueConstrastDress4.webp";

import blueDay1 from "../images/dress/blueDay1.webp";
import blueDay2 from "../images/dress/blueDay2.webp";
import blueDay3 from "../images/dress/blueDay3.webp";
import blueDay4 from "../images/dress/blueDay4.webp";

import blueDressGoldenFlower1 from "../images/dress/blueDressGoldenFlower1.webp";
import blueDressGoldenFlower2 from "../images/dress/blueDressGoldenFlower2.webp";
import blueDressGoldenFlower3 from "../images/dress/blueDressGoldenFlower3.webp";
import blueDressGoldenFlower4 from "../images/dress/blueDressGoldenFlower4.webp";
import blueDressGoldenFlower5 from "../images/dress/blueDressGoldenFlower5.webp";
import blueDressGoldenFlower6 from "../images/dress/blueDressGoldenFlower6.webp";
import blueDressGoldenFlower7 from "../images/dress/blueDressGoldenFlower7.webp";

import goldenAccentsDress1 from "../images/dress/goldenAccentsDress1.webp";
import goldenAccentsDress2 from "../images/dress/goldenAccentsDress2.webp";
import goldenAccentsDress3 from "../images/dress/goldenAccentsDress3.webp";
import goldenAccentsDress4 from "../images/dress/goldenAccentsDress4.webp";
import goldenAccentsDress5 from "../images/dress/goldenAccentsDress5.webp";
import goldenAccentsDress6 from "../images/dress/goldenAccentsDress6.webp";
import goldenAccentsDress7 from "../images/dress/goldenAccentsDress7.webp";
import goldenAccentsDress8 from "../images/dress/goldenAccentsDress8.webp";

import goldenDressRedDupata1 from "../images/dress/goldenDressRedDupata1.webp";
import goldenDressRedDupata2 from "../images/dress/goldenDressRedDupata2.webp";
import goldenDressRedDupata3 from "../images/dress/goldenDressRedDupata3.webp";
import goldenDressRedDupata4 from "../images/dress/goldenDressRedDupata4.webp";

import greenDressGoldAccents1 from "../images/dress/greenDressGoldAccents1.webp";
import greenDressGoldAccents2 from "../images/dress/greenDressGoldAccents2.webp";
import greenDressGoldAccents3 from "../images/dress/greenDressGoldAccents3.webp";
import greenDressGoldAccents4 from "../images/dress/greenDressGoldAccents4.webp";
import greenDressGoldAccents5 from "../images/dress/greenDressGoldAccents5.webp";

import purpleWithGlitter1 from "../images/dress/purpleWithGlitter1.webp";
import purpleWithGlitter2 from "../images/dress/purpleWithGlitter2.webp";
import purpleWithGlitter3 from "../images/dress/purpleWithGlitter3.webp";
import purpleWithGlitter4 from "../images/dress/purpleWithGlitter4.webp";
import purpleWithGlitter5 from "../images/dress/purpleWithGlitter5.webp";

import redDressGoldAccents1 from "../images/dress/redDressGoldAccents1.webp";
import redDressGoldAccents2 from "../images/dress/redDressGoldAccents2.webp";
import redDressGoldAccents3 from "../images/dress/redDressGoldAccents3.webp";
import redDressGoldAccents4 from "../images/dress/redDressGoldAccents4.webp";
import redDressGoldAccents5 from "../images/dress/redDressGoldAccents5.webp";
import redDressGoldAccents6 from "../images/dress/redDressGoldAccents6.webp";
import redDressGoldAccents7 from "../images/dress/redDressGoldAccents7.webp";

import redFlowerDress1 from "../images/dress/redFlowerDress1.webp";
import redFlowerDress2 from "../images/dress/redFlowerDress2.webp";
import redFlowerDress3 from "../images/dress/redFlowerDress3.webp";

import redGoldenBlouseDress1 from "../images/dress/redGoldenBlouseDress1.webp";
import redGoldenBlouseDress2 from "../images/dress/redGoldenBlouseDress2.webp";
import redGoldenBlouseDress3 from "../images/dress/redGoldenBlouseDress3.webp";
import redGoldenBlouseDress4 from "../images/dress/redGoldenBlouseDress4.webp";
import redGoldenBlouseDress5 from "../images/dress/redGoldenBlouseDress5.webp";
import redGoldenBlouseDress6 from "../images/dress/redGoldenBlouseDress6.webp";
import redGoldenBlouseDress7 from "../images/dress/redGoldenBlouseDress7.webp";
import redGoldenBlouseDress8 from "../images/dress/redGoldenBlouseDress8.webp";

export const womensCollection = [
  {
    id: "w1",
    title: "Midnight Reverie",
    price: "$88",
    defaultImage: blackGoldenDress1,
    allImages: [
      blackGoldenDress1,
      blackGoldenDress2,
      blackGoldenDress3,
      blackGoldenDress4,
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["S", "M", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Designed for a comfortable and flattering fit, crafted from high-quality fabric for all-day ease and effortless style. Since we have multiple fabric option, please contact us for more details.",
      },
      {
        title: "Description",
        description:
          "This stunning black and gold dress is designed to turn heads with its sophisticated elegance and subtle allure. The rich black fabric contrasts beautifully with intricate golden accents that catch the light, creating a timeless, luxurious effect. The dress features a flattering silhouette that enhances your figure, with thoughtful details that add a touch of intrigue. Perfect for an evening out or a special occasion, this dress embodies a perfect balance of classic style and modern elegance, making it a must-have in any fashion-forward wardrobe.",
      },
    ],
  },
  {
    id: "w2",
    title: "Twilight Enchantment",
    price: "$78",
    defaultImage: blueBlackDress2,
    allImages: [
      blueBlackDress1,
      blueBlackDress2,
      blueBlackDress3,
      blueBlackDress4,
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["S", "M", "L", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Designed for a comfortable and flattering fit, crafted from high-quality fabric for all-day ease and effortless style. Since we have multiple fabric option, please contact us for more details.",
      },
      {
        title: "Description",
        description:
          "A captivating blend of deep blue and black, this dress exudes a sense of mystery and elegance. The rich, dark hues come together seamlessly, offering a sophisticated look that’s perfect for both formal and semi-formal occasions. The fabric drapes beautifully, creating a flattering silhouette that enhances your natural shape. Subtle yet striking details add a touch of glamour, making this dress a versatile statement piece. Whether it's an evening gala or a romantic dinner, the 'Twilight Enchantment' ensures you radiate grace and poise.",
      },
    ],
  },
  {
    id: "w3",
    title: "Starlight Dazzle",
    price: "$88",
    defaultImage: purpleWithGlitter4,
    allImages: [
      purpleWithGlitter1,
      purpleWithGlitter2,
      purpleWithGlitter3,
      purpleWithGlitter4,
      purpleWithGlitter5,
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["XS", "S", "M", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Designed for a comfortable and flattering fit, crafted from high-quality fabric for all-day ease and effortless style. Since we have multiple fabric option, please contact us for more details.",
      },
      {
        title: "Description",
        description:
          "Sparkling with every movement, this purple glitter dress is designed to captivate and shine. The delicate glitter detailing catches the light, creating a mesmerizing effect that adds a dash of glamour to your evening. The rich purple hue offers a bold yet elegant statement, while the dress' tailored fit accentuates your figure in all the right ways. Perfect for a night out or a special celebration, the 'Starlight Dazzle' is a showstopper that combines timeless style with a touch of playful sparkle.",
      },
    ],
  },
  {
    id: "w4",
    title: "Vivid Eclipse",
    price: "$138",
    defaultImage: blackMultiColor2,
    allImages: [
      blackMultiColor1,
      blackMultiColor2,
      blackMultiColor3,
      blackMultiColor4,
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["S", "M", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Designed for a comfortable and flattering fit, crafted from high-quality fabric for all-day ease and effortless style. Since we have multiple fabric option, please contact us for more details.",
      },
      {
        title: "Description",
        description:
          "Bold and dynamic, this black multi-color dress features a stunning array of vibrant hues that dance across the fabric, creating a modern, artistic flair. The black backdrop allows the striking colors to pop, while the carefully crafted design ensures a flattering fit. With a harmonious balance of elegance and excitement, this dress is perfect for making a statement at any occasion, whether a cocktail party or a chic evening event. The 'Vivid Eclipse' effortlessly combines sophistication with an eye-catching burst of color, ensuring you stand out with grace.",
      },
    ],
  },
  {
    id: "w5",
    title: "Celestial Harmony",
    price: "$78",
    defaultImage: blueConstrastDress3,
    allImages: [
      blueConstrastDress1,
      blueConstrastDress2,
      blueConstrastDress3,
      blueConstrastDress4,
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["S", "M", "XL", "XXL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Designed for a comfortable and flattering fit, crafted from high-quality fabric for all-day ease and effortless style. Since we have multiple fabric option, please contact us for more details.",
      },
      {
        title: "Description",
        description:
          "This blue contrast dress is a perfect fusion of bold design and timeless elegance. With its striking contrasts, the dress features a sophisticated interplay of deep blue and lighter accents, creating a figure-flattering silhouette that exudes confidence. The clean lines and expertly tailored structure offer a polished look, while the contrast detailing adds an unexpected touch of modernity. Ideal for a range of occasions, from formal gatherings to cocktail parties, the 'Celestial Harmony' brings together classic charm with contemporary flair, ensuring you make a lasting impression.",
      },
    ],
  },
  {
    id: "w6",
    title: "Oceanic Dream",
    price: "$78",
    defaultImage: blueDay3,
    allImages: [blueDay1, blueDay2, blueDay3, blueDay4],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["XS", "S", "M", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Designed for a comfortable and flattering fit, crafted from high-quality fabric for all-day ease and effortless style. Since we have multiple fabric option, please contact us for more details.",
      },
      {
        title: "Description",
        description:
          "A graceful tribute to the various shades of the ocean, this multiple blue dress blends hues from deep navy to serene turquoise. The cascading layers of blues create a mesmerizing, fluid effect that moves beautifully with every step. The dress is designed to flatter the body with its structured fit and gentle flow, offering both elegance and comfort. Whether it's a formal evening or a sophisticated daytime event, the 'Oceanic Dream' adds a fresh, vibrant twist to your wardrobe, making a statement of both style and tranquility.",
      },
    ],
  },
  {
    id: "w7",
    title: "Golden Bloom",
    price: "$78",
    defaultImage: blueDressGoldenFlower1,
    allImages: [
      blueDressGoldenFlower1,
      blueDressGoldenFlower2,
      blueDressGoldenFlower3,
      blueDressGoldenFlower4,
      blueDressGoldenFlower5,
      blueDressGoldenFlower6,
      blueDressGoldenFlower7,
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["XS", "S", "M", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Designed for a comfortable and flattering fit, crafted from high-quality fabric for all-day ease and effortless style. Since we have multiple fabric option, please contact us for more details.",
      },
      {
        title: "Description",
        description:
          "This exquisite blue dress is brought to life with delicate golden flower accents that add a touch of elegance and charm. The rich blue fabric serves as a beautiful canvas, while the intricate golden floral embroidery creates a stunning contrast that catches the light with every movement. The dress offers a graceful, flattering fit, with a timeless design that’s both sophisticated and eye-catching. Perfect for an evening celebration or a special occasion, the 'Golden Bloom' combines classic beauty with a hint of floral magic, ensuring you stand out with poise and style.",
      },
    ],
  },
  {
    id: "w8",
    title: "Elysian Glow",
    price: "$78",
    defaultImage: goldenAccentsDress1,
    allImages: [
      goldenAccentsDress1,
      goldenAccentsDress2,
      goldenAccentsDress3,
      goldenAccentsDress4,
      goldenAccentsDress5,
      goldenAccentsDress6,
      goldenAccentsDress7,
      goldenAccentsDress8,
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["XS", "S", "L", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Designed for a comfortable and flattering fit, crafted from high-quality fabric for all-day ease and effortless style. Since we have multiple fabric option, please contact us for more details.",
      },
      {
        title: "Description",
        description:
          "Soft and radiant, this light yellow dress is elevated by exquisite golden accents that bring an air of elegance and warmth. The subtle yellow tone evokes a sense of sunshine and joy, while the golden details—whether in delicate embroidery or tasteful embellishments—add a sophisticated shimmer. The dress’s design offers a graceful, flattering fit, perfect for a variety of occasions. Whether you’re attending a garden party, a summer soirée, or a formal event, the 'Elysian Glow' captures the essence of light and luxury, ensuring you glow with every step.",
      },
    ],
  },
  {
    id: "w9",
    title: "Regal Mirage",
    price: "$78",
    color: "red",
    defaultImage: goldenDressRedDupata1,
    allImages: [
      goldenDressRedDupata1,
      goldenDressRedDupata2,
      goldenDressRedDupata3,
      goldenDressRedDupata4,
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["S", "M", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Designed for a comfortable and flattering fit, crafted from high-quality fabric for all-day ease and effortless style. Since we have multiple fabric option, please contact us for more details.",
      },
      {
        title: "Description",
        description:
          "This stunning golden dress radiates luxury and elegance, beautifully paired with a rich red dupatta that adds a striking contrast. The lustrous gold fabric catches the light with every movement, exuding sophistication, while the bold red dupatta drapes gracefully, offering a touch of traditional allure. The intricate design of the dress enhances its timeless appeal, making it a perfect choice for formal occasions or cultural celebrations. The 'Regal Mirage' is a harmonious blend of opulence and grace, ensuring you make a memorable statement wherever you go.",
      },
    ],
  },
  {
    id: "w10",
    title: "Emerald Majesty",
    price: "$78",
    defaultImage: greenDressGoldAccents1,
    allImages: [
      greenDressGoldAccents1,
      greenDressGoldAccents2,
      greenDressGoldAccents3,
      greenDressGoldAccents4,
      greenDressGoldAccents5,
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["XS", "S", "M", "L", "XL", "XXXL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Designed for a comfortable and flattering fit, crafted from high-quality fabric for all-day ease and effortless style. Since we have multiple fabric option, please contact us for more details.",
      },
      {
        title: "Description",
        description:
          "Elevate your festive wardrobe with this stunning bottle green three piece set . Featuring a luxurious lehenga, a fitter bustier and a graceful dupatta, each piece is intricately crafted with exquisite brocade design detailing. The rich mono chrome shade, and timeless craftsmanship, make this set perfect for wedding and special occasion, blending Classic beauty with modern elegance.",
      },
    ],
  },
  {
    id: "w11",
    title: "Crimson Luxe",
    price: "$78",
    color: "red",
    defaultImage: redDressGoldAccents1,
    allImages: [
      redDressGoldAccents1,
      redDressGoldAccents2,
      redDressGoldAccents3,
      redDressGoldAccents4,
      redDressGoldAccents5,
      redDressGoldAccents6,
      redDressGoldAccents7,
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["S", "M", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Designed for a comfortable and flattering fit, crafted from high-quality fabric for all-day ease and effortless style. Since we have multiple fabric option, please contact us for more details.",
      },
      {
        title: "Description",
        description:
          "This stunning lehenga set features a top with a unique pleated design that creates a flattering, structured silhouette. The delicate pleats add texture and dimension, perfectly complementing the ruffle detail lehenga. Finished with golden edging, this ensemble exudes elegance and modern flair, ideal for any festive or celebratory occasion.",
      },
    ],
  },
  {
    id: "w12",
    title: "Floral Ember",
    price: "$78",
    color: "red",
    defaultImage: redFlowerDress1,
    allImages: [redFlowerDress1, redFlowerDress2, redFlowerDress3],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["S", "M", "L", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Designed for a comfortable and flattering fit, crafted from high-quality fabric for all-day ease and effortless style. Since we have multiple fabric option, please contact us for more details.",
      },
      {
        title: "Description",
        description:
          "Like the petals of a blooming flower, this red dress radiates beauty and elegance. The vibrant red hue evokes the passion and warmth of a fiery blossom, while the subtle floral-inspired details—whether in delicate embroidery, layered ruffles, or soft pleats—capture the essence of nature’s grace. The dress flows beautifully, enhancing your figure with a feminine silhouette that’s perfect for any special occasion. The 'Floral Ember' is a breathtaking fusion of boldness and delicacy, ensuring you stand out with timeless charm and effortless style.",
      },
    ],
  },
  {
    id: "w13",
    title: "Scarlet Radiance",
    price: "$78",
    color: "red",
    defaultImage: redGoldenBlouseDress1,
    allImages: [
      redGoldenBlouseDress1,
      redGoldenBlouseDress2,
      redGoldenBlouseDress3,
      redGoldenBlouseDress4,
      redGoldenBlouseDress5,
      redGoldenBlouseDress6,
      redGoldenBlouseDress7,
      redGoldenBlouseDress8,
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["XS", "S", "M", "L", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Designed for a comfortable and flattering fit, crafted from high-quality fabric for all-day ease and effortless style. Since we have multiple fabric option, please contact us for more details.",
      },
      {
        title: "Description",
        description:
          "This vibrant two piece set features a one shoulder crop top in a stunning gradient of pink, orange and red with golden shimmer detailing, paired with a flowing cowl style skirt. Perfect for any occasion, it combines bold color with elegant movement, offering a flattering, comfortable fit that will make you stand out effortlessly.",
      },
    ],
  },
];
